import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "antd";
import axios from "axios";
import 'bootstrap-icons/font/bootstrap-icons.css';
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import * as links from "../../../../utils/links";
import "./ListaMaquinas.css";

import {
  faArrowsRotate,
  faCheckCircle,
  faXmarkCircle
} from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useParams } from "react-router-dom";

const ListaMaquinas = (props) => {
  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const location = useLocation();

  const clienteInfo = location.state;

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [totalClienteMaquinas, setTotalClienteMaquinas] = useState([]);
  const [totalClienteMaquinasOffline, setTotalClienteMaquinasOffline] = useState([]);
  const [maquinasInfos, setMaquinasInfos] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const dataData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/machines-adm`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setTotalClienteMaquinas(res.data.maquinasOnline);
          setTotalClienteMaquinasOffline(res.data.maquinasOffline);
          setMaquinasInfos(res.data);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser.key === 'ADMIN') {
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          } else {
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
      });
  };

  return (
    <div className="Cliente_Maquinas_container">
      {isLoading && <LoadingAction />}
      <div className="WarningMsgSpan">
        <span>{dataUser.warningMsg}</span>
      </div>
      <div className="AddCliente_header">
        <div className="AddCliente_header_title">Máquinas:</div>
        <Link className="AddCliente_header_back" to={links.DASHBOARD_CLIENTES}>
          VOLTAR
        </Link>
      </div>
      <div className="Cliente_Maquinas_action">
        <Button style={{ margin: "0 15px" }}
          onClick={() =>
            dataData()
          }>
          <FontAwesomeIcon
            icon={faArrowsRotate}
            style={{ marginRight: "5px" }}
          />
          Atualizar
        </Button>
      </div>
      <div style={{ marginLeft: '15px', marginTop: '20px' }}>
        <Row>
          <h6>Total:{maquinasInfos?.total}</h6>
          <h6 style={{ marginLeft: '15px' }}>Online:{maquinasInfos?.online}</h6>
          <h6 style={{ marginLeft: '15px' }}>Offline:{maquinasInfos?.offline}</h6>
        </Row>
      </div>
      <Row style={{ margin: '30px 0 -15px 15px' }}>
        <h6>Máquinas Online:</h6>
      </Row>
      <Row>
        {totalClienteMaquinas.map((post) => (
          <Col xs={24} md={24} lg={8} xl={8} className="Cliente_Maquinas_col">
            <div>
              <div className="maquina" key={post.id} onClick={() => null}>
                <div className="maquina-info">
                  {(() => {
                    switch (post.status) {
                      case "PAGAMENTO_RECENTE":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"blue"}
                              className="logout-icon fa-3x"
                            />
                            <b>{post.nivelDeSinal ? `${post.nivelDeSinal}%` : null}</b>
                          </div>
                        );
                      case "online":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"green"}
                              className="logout-icon fa-3x"
                            />
                            <b>{post.nivelDeSinal ? `${post.nivelDeSinal}%` : null}</b>
                          </div>
                        );
                      case "offline":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faXmarkCircle}
                              color={"red"}
                              className="logout-icon fa-3x"
                            />
                            {
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent' }}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      default:
                        return null;
                    }
                  })()}

                  <h2>{post.nome}</h2>
                  <h6 style={{ fontWeight: "300" }}>
                    {post.status} - {post.descricao}
                  </h6>
                  <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                  <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
                  <h6 style={{ fontWeight: "300" }}>Cliente: {post.clienteNome}</h6>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <Row style={{ margin: '30px 0 -15px 15px' }}>
        <h6>Máquinas Offline:</h6>
      </Row>
      <Row>
        {totalClienteMaquinasOffline.map((post) => (
          <Col xs={24} md={24} lg={8} xl={8} className="Cliente_Maquinas_col">
            <div>
              <div className="maquina" key={post.id} onClick={() => null}>
                <div className="maquina-info">
                  {(() => {
                    switch (post.status) {
                      case "online":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"green"}
                              className="logout-icon fa-3x"
                            />
                            <b>{post.nivelDeSinal ? `${post.nivelDeSinal}%` : null}</b>
                          </div>
                        );
                      case "offline":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faXmarkCircle}
                              color={"red"}
                              className="logout-icon fa-3x"
                            />
                            {
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>

                                }>
                                <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent' }}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      default:
                        return null;
                    }
                  })()}

                  <h2>{post.nome}</h2>
                  <h6 style={{ fontWeight: "300" }}>
                    {post.status} - {post.descricao}
                  </h6>
                  <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                  <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
                  <h6 style={{ fontWeight: "300" }}>Cliente: {post.clienteNome}</h6>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ListaMaquinas;
